
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[article]",
      function () {
        return require("private-next-pages/[region]/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[article]"])
      });
    }
  